import { useLanguage } from "../../../../contexts/LanguageContext"
import ModalHeader from "./ModalHeader"
import WelcomeMessage from "./WelcomeMessage"
import SearchBar from "./SearchBar"
import NewsSection from "./NewsSection"
import StepByStepSection from "./StepByStepSection"
import FaqSection from "./FaqSection"
import ModalFooter from "./ModalFooter"

/**
 * Main Shortways assistant window component.
 * Orchestrates the complete assistant interface by combining all sections and components.
 * @param {Object} props
 * @param {Object} props.parameters - Assistant configuration parameters
 * @returns {JSX.Element}
 */
export default function PreviewMainPopup({ parameters }) {
  const { t } = useLanguage()

  return (
    <div>
      <div className="preview_headerBloc">{t("AssistantWindow.assistantWindowTitle")}</div>
      <div className="modal-content react-draggable react-draggable-dragged" id="mainPopupDraggable">
        <ModalHeader />
        <div className="modal-body tall">
          <div className="tab-content">
            <div className="tab-pane fade show active" role="tabpanel">
              <div className="shortwaysWelcomeScreen">
                <WelcomeMessage parameters={parameters} />
                <SearchBar />
                <NewsSection parameters={parameters} />
                <StepByStepSection parameters={parameters} />
                <FaqSection parameters={parameters} />
              </div>
            </div>
          </div>
        </div>
        <ModalFooter parameters={parameters} />
      </div>
    </div>
  )
}
